import React from 'react';
import { PropTypes } from 'prop-types';

const LocationMapError = ({ mapUrl }) => {
	return (
		<a
			target="_blank"
			href={mapUrl}
			rel="noopener noreferrer"
			className="location-map d-flex flex-column pl-sm-5 pr-sm-3 cursor-pointer "
			aria-label="Open map in new window - Map temporarily unavailable"
			title="Open map in new window - Map temporarily unavailable"
		>
			<div
				className="location-map__error-container w-100 d-flex align-items-center justify-content-center bg-light border-radius-md"
				role="img"
				aria-label="Map unavailable"
			>
				<div className="text-center text-muted">
					<svg
						width="48"
						height="48"
						viewBox="0 0 24 24"
						fill="currentColor"
						className="mb-2"
						aria-hidden="true"
					>
						<path
							d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z
							m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
						/>
					</svg>
					<p className="mb-0">Map temporarily unavailable</p>
				</div>
			</div>
		</a>
	);
};

LocationMapError.propTypes = {
	mapUrl: PropTypes.string.isRequired
};

export default LocationMapError;
